module.exports = __webpack_public_path__ + "img/overview_separate.9e09ba08.svg";